import "./lib/supabaseAuthPatch";
import React from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import App from "./App.tsx";
import "./index.css";

// Initialise Sentry before rendering
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
